import { AgmMap } from '@agm/core';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { sweetAlert } from 'src/app/utils/swal';
import { AssigTripsService } from '../../component/assigned-trips/assigntrips-service/assigntrips-service';
import { timeCalculation } from '../../utils/utils.common';
import { KpisService } from '../../component/kpis/kpis-service/kpis.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { DriversService } from '../../component/drivers/drivers-service/drivers-service';
import { environment } from 'src/environments/environment';
import { ServiceAreasAddComponent } from '../../component/service-areas/service-areas-add/service-areas-add.component';
import { ServiceAreasService } from '../../component/service-areas/service-areas-service/service-areas.service';
import { LevelOfServiceService } from '../../component/level-of-service/service/level-of-service.service';
import { CorporateService } from '../../component/corporate-user/corporate-service/corporate-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { FleetService } from 'src/app/component/fleet/fleet-service/fleet.service';
import { FarmoutService } from 'src/app/service/farmout-service/farmout.service';

@Component({
  selector: 'app-trip-detail-model',
  templateUrl: './trip-detail-model.component.html',
  styleUrls: ['./trip-detail-model.component.css']
})
export class TripDetailModelComponent implements OnInit, OnDestroy {
  @Input('tripDetailModalObj') trip: any;
  @Input() source: any;
  @Input() corporatesByKey: any
  @ViewChild("AgmMap", { static: false }) agmElement: AgmMap;
  @Output() onCloseModal = new EventEmitter<string>();
  agmMap;
  bounds;
  latitude: number;
  longitude: number;
  zoom: number = 12;
  eta;
  contact;
  tripData: any;
  driverDetails;
  preferredDriverDetails;

  trackinURL;
  serviceAreas: any;
  user;
  isFarmoutIntegration = false
  assistList;
  driverList:any;
  selectedStatus = 'active';
  preDrivers = {};

  constructor(
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private serviceArea: ServiceAreasService,
    private assignTripService: AssigTripsService,
    private kpisService: KpisService,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private fleetService: FleetService,
  ) { }

  ngOnInit() {
    if(this.trip.attendees){
      this.getAssistByid();
    }
    this.trackinURL = environment.TRACKING_URL;
    this.getUser();
    if (this.source === "statistics") {
      this.getTripDetails();
    }
    
    
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          if (user.hasOwnProperty('isFarmout')) {
            this.isFarmoutIntegration = user.isFarmout
          }
          this.getTrips();
        }
      });
  }

  getTrips() {
    this.assignTripService
      .tripDetail(this.trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.tripData = data;
            if (this.tripData.driver) {
              this.getDriverDetails(this.tripData.driver);
            }

            if (this.tripData.preferredDriver) {
              this.getPreferredDriverData(this.tripData.preferredDriver);
            }

            if (data.priorityClient) {
              this.contact = data.priorityClient.contactNumber;
            }
            this.getServiceAreas();
            this.getLevelOfServicebyId();
            this.getSpaceTypesbyId();
            this.getCorporateUserById();
          }
        });
  }

  closeModal() {
    this.onCloseModal.emit();
  }

  getDriverDetails(id) {
    this.driverService
      .getDriverProfile(id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverDetails = data;
        }
      });
  }

  getETA(tripId) {
    this.assignTripService
      .getETA(tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.etaMessage) {
          this.eta = data.etaMessage;
        }
      });
  }

  sendSMS() {
    if (!this.contact) return;
    this.trip.contactNumber = this.contact;

    const payload = {
      ...this.trip,
      tripId: this.trip._id,
      latitude: this.trip.driver.latitude,
      longitude: this.trip.driver.longitude,
    }
    this.assignTripService
      .sendTrackingSMS(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // this.contact = '';
          if (data.success) {
            sweetAlert('Success', data.message, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
        }
      });
  }
  // sendMessage
  getTripDetails() {
    this.kpisService.getNemtStatsById(this.trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.trip = data;
        }
      })
  }

  getJobStatus(status) {
    let tripStatus = status;

    if (status === 'pending') {
      tripStatus = 'Unassigned';
    } else if (status === 'arrived') {
      tripStatus = 'On Scene';
    } else if (status === 'started') {
      tripStatus = 'Member Onboard';
    }

    return tripStatus
  }

  breakString(str) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }

  getPayorTypeTitle(corporateId, payorType) {
    if (!this.corporatesByKey) return;

    let payor;
    let types = this.corporatesByKey[corporateId];
    if (types && types.length) {
      payor = types.find(t => t.value === payorType);
    }
    return payor ? payor.title : '';
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreas = data;
            const sArea = this.serviceAreas.find((item) => item._id === this.tripData.serviceArea);
            this.tripData.serviceArea = sArea ? sArea.name : 'N/A';
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getLevelOfServicebyId() {
    this.levelOfServiceService.getLevelOfServicebyId(this.tripData.los)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.tripData.los = data.title

          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getSpaceTypesbyId() {
    this.levelOfServiceService.getServiceTypebyId(this.tripData.spaceType)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.tripData.spaceType = data.title
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getCorporateUserById() {
    this.corporateService.getCorporateUserById(this.tripData.cooperate)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.tripData.cooperate = data.displayName
        }

      });
  }

  getAssistByid() {
    this.driverService
      .getAssistsByIDs(this.trip.attendees)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.assistList = data;
        }
      });
  }


    getPreferredDriverData(driverId) {
    this.driverService
      .getDriversByID(driverId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preferredDriverDetails = data;
        }
      });
  }

  ngOnDestroy(): void {
  }
}
